import styled from "styled-components";
import { Typography } from "antd";

const { Text } = Typography;
export const StyledContainer = styled.div`
	background: ${(props) => (props.isExitModal ? "transparent" : "#00000040")};
	position: fixed;
	top: 0;
	z-index: 10001;
	width: 100%;
	height: 100vh;
	display: flex;
	align-items: center;
	left: 0;

	& button {
		width: 80%;
	}
	display: ${(props) => (props.isClose ? "none" : "flex")};
`;

export const StyledModal = styled.div`
	display: flex;

	width: ${(props) => (props.desktop ? "360px" : "330px")};
	height: ${(props) =>
		props.desktop ? "480px" : props.temporaryUserPopUp ? "340px" : "490px"};
	text-align: center;
	background: #fefefe;
	font-family: "Montserrat";
	margin: 0 auto;
	border-radius: 20px;
	box-shadow: 0px 0px 7px 2px rgba(0, 0, 0, 0.4);

	@media (min-width: 768px) {
		max-width: 460px;
	}

	.text__container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #000;
	}
`;

export const StyledDiv = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	/* justify-content: space-evenly; */
	width: 90%;
	height: 90%;
	margin: 0 auto;
`;

export const Avatar = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	width: 80px;
	height: 80px;
	overflow: hidden;
	border-radius: 50%;
	box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.3);
	background: ${(props) => {
		return props.isLoggedInTemporary ? props.theme.colors.blue_bg : "";
	}};
`;
export const TitleStyled = styled(Text)`
	color: ${(props) => props.theme.colors.blue_bg};
	font-weight: 700;
	font-size: 16px;
`;

export const ButtonContainer = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-around;

	& button {
		width: 45%;
	}
`;
